import React, { useRef } from "react";
import emailjs from "emailjs-com";

import contactHero from "../assets/contact-hero.png";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_haqlfpw",
        "template_gyyjqac",
        form.current,
        "lVn7rYlbLO8Ns29aa"
      )
      .then(
        () => {
          alert("Message Sent Successfully ✅");
          form.current.reset();
        },
        () => {
          alert("Failed to send ❌");
        }
      );
  };

  return (
    <div className="text-white">

      {/* HERO */}
      <section
        className="relative h-[80vh] flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${contactHero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/80"></div>

        <div className="relative z-10 px-6">
          <h1 className="text-5xl md:text-7xl font-bold">
            Get In <span className="text-purple-400">Touch</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto">
            Let’s build something amazing together 🚀
          </p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="py-24 px-6 bg-[#0b1a35]">

        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">

          {/* FORM */}
          <form
            ref={form}
            onSubmit={sendEmail}
            className="bg-[#112240] p-8 rounded-xl space-y-6"
          >
            <h2 className="text-3xl font-bold text-purple-400">
              Send Message
            </h2>

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              className="w-full p-3 rounded bg-[#0b1a35] outline-none"
            />

            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
              className="w-full p-3 rounded bg-[#0b1a35] outline-none"
            />

            <textarea
              name="message"
              rows="5"
              placeholder="Your Message"
              required
              className="w-full p-3 rounded bg-[#0b1a35] outline-none"
            ></textarea>

            <button className="w-full py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg hover:scale-105 transition">
              Send Message
            </button>
          </form>

          {/* CONTACT OPTIONS */}
          <div className="space-y-8">

            <div className="bg-[#112240] p-6 rounded-xl">
              <h3 className="text-xl font-semibold text-purple-400">
                Schedule a Meeting
              </h3>

              <p className="text-gray-400 mt-2">
                Book a meeting directly with us.
              </p>

              <a
                href="https://calendly.com/thelogicwaves/30min"
                target="_blank"
                rel="noreferrer"
              >
                <button className="mt-4 px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg hover:scale-105 transition">
                  Book Now
                </button>
              </a>
            </div>

            <div className="bg-[#112240] p-6 rounded-xl">
              <h3 className="text-xl font-semibold text-green-400">
                WhatsApp Us
              </h3>

              <p className="text-gray-400 mt-2">
                Quick chat directly on WhatsApp.
              </p>

              <a
                href="https://wa.me/+923009609342"
                target="_blank"
                rel="noreferrer"
              >
                <button className="mt-4 px-6 py-2 bg-green-500 rounded-lg hover:scale-105 transition">
                  Chat Now
                </button>
              </a>
            </div>

            <div className="bg-[#112240] p-6 rounded-xl">
              <h3 className="text-xl font-semibold text-pink-400">
                Email
              </h3>

              <p className="text-gray-400 mt-2">
                thelogicwaves@gmail.com
              </p>
            </div>

          </div>

        </div>

      </section>

    </div>
  );
};

export default Contact;